import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { defaultCssVariables } from 'core/styled';

const StyleText = styled.span<{
    weight: TextFontWeights;
    type: TextFontSizes;
    opacity?: number;
    isTruncated?: boolean;
}>`
    font-size: ${({ theme, type }) =>
        type ? theme.base.font.size[type] : theme.feature.text.fontSize};
    font-family: ${({ theme }) => theme.feature.text.fontFamily};
    line-height: ${({ theme }) => theme.feature.text.lineHeight};
    font-weight: ${({ theme, weight }) => weight || theme.feature.text.weight};
    color: ${({ theme }) => theme.feature.text.color};
    opacity: ${({ opacity }) => opacity || 1};
    ${({ isTruncated }) =>
        isTruncated &&
        `
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        `}
`;

export type TextFontWeights = keyof typeof defaultCssVariables.font.weight;
export type TextFontSizes = keyof typeof defaultCssVariables.font.size;

export type TextStyleprops = {
    weight?: TextFontWeights;
    type?: TextFontSizes;
    opacity?: number;
    values?: Record<string, string | number | Date>;
    isTruncated?: boolean;
};

export const TextStyle: React.FunctionComponent<PropsWithChildren<TextStyleprops>> = ({
    children,
    type = 'normal',
    weight = 'regular',
    opacity,
    isTruncated,
    ...otherProps
}) => {
    return (
        <StyleText {...{ type, weight, opacity, isTruncated }} {...otherProps}>
            {children}
        </StyleText>
    );
};
